module.exports = __webpack_public_path__ + "static/media/classic_peach.21439287.png";